import Component from './exterior';

export default Component;